import { NOT_SET } from '@utils/tracking/constants';

export default function getShopDeliveryTime({ isPickup, deliveryTime }) {
  const { minMinutes, maxMinutes } = deliveryTime || {};
  const hasValidDeliveryTime = Boolean(minMinutes && maxMinutes);
  if (isPickup) {
    return maxMinutes ? `${maxMinutes} min` : NOT_SET;
  }
  return hasValidDeliveryTime ? `${minMinutes} - ${maxMinutes} min` : NOT_SET;
}
